import { API_ROOT } from '../../http_client';

export const API_PREFIX = '/api';
export const EDUCATION_API = `${API_ROOT}/educationlevel`;
export const TITLE_API = `${API_ROOT}/title`;
export const EXPORT_API = 'export';
export const REPORT_API = 'report';
